const articles = [
  {
    id: "0",
    author: "Claire Robinson",
    title: "Receive money in any currency with no fees",
    text: "The world is getting smaller and we're becoming more mobile. So why should you be forced to only receive money in a single ...",
    image: "images/image-currency.jpg",
  },
  {
    id: "1",
    author: "Wilson Hutton",
    title: "Treat yourself without worrying about money",
    text: "Our simple budgeting feature allows you to separate out your spending and set realistic limits each month. That means you ...",
    image: "images/image-restaurant.jpg",
  },
  {
    id: "2",
    author: "Wilson Hutton",
    title: "Take your Easybank card wherever you go",
    text: "We want you to enjoy your travels. This is why we don't charge any fees on purchases while you're abroad. We'll even show you ...",
    image: "images/image-plane.jpg",
  },
  {
    id: "0",
    author: "Claire Robinson",
    title: "Our invite-only Beta accounts are now live!",
    text: "After a lot of work by the whole team, we're excited to launch our beta. It's easy to request an invite through the site ...",
    image: "images/image-confetti.jpg",
  },
];

export default articles;
